export const ADD_USER = "@listOfUser/ADD"
